<div class="portal-users-container" *ngIf="portalUsersPageGrid && portalUsersPageGrid.filtersForm">
  <!-- Header Section -->
  <div class="page-header">
    <div class="header-content">
      <h1 class="page-title">
        <i class="icon-user icon-lg"></i>
        Portal Users Management
      </h1>
      <p class="page-subtitle">Manage and monitor portal user accounts</p>
    </div>
    <div class="header-actions">
      <button mat-raised-button color="primary" (click)="refreshUsers()" [disabled]="gridInProgress">
        <i class="icon-refresh"></i>
        Refresh
      </button>
    </div>
  </div>

  <!-- Filters Section -->
  <div class="filters-section">
    <div class="filters-row">
      <div class="search-filter">
        <mat-form-field appearance="outline" class="search-field">
          <mat-label>Search users</mat-label>
          <input matInput [formControl]="portalUsersPageGrid.filtersForm.get('searchTerm')" placeholder="Search by name, email, or NIC" />
          <mat-icon matSuffix>search</mat-icon>
        </mat-form-field>
      </div>

      <!-- <div class="dropdown-filters">
        <mat-form-field appearance="outline" class="filter-field">
          <mat-label>Status</mat-label>
          <mat-select [formControl]="portalUsersPageGrid.filtersForm.get('statusFilter')">
            <mat-option value="ALL">All Status</mat-option>
            <mat-option value="ACTIVE">Active</mat-option>
            <mat-option value="INACTIVE">Inactive</mat-option>
            <mat-option value="PENDING">Pending</mat-option>
          </mat-select>
        </mat-form-field>

        <mat-form-field appearance="outline" class="filter-field">
          <mat-label>Role</mat-label>
          <mat-select [formControl]="portalUsersPageGrid.filtersForm.get('roleFilter')">
            <mat-option value="ALL">All Roles</mat-option>
            <mat-option value="ADMIN">Admin</mat-option>
            <mat-option value="USER">User</mat-option>
            <mat-option value="MANAGER">Manager</mat-option>
          </mat-select>
        </mat-form-field>

        <button mat-button (click)="clearFilters()" class="clear-filters-btn">
          <i class="icon-close"></i>
          Clear Filters
        </button>
      </div> -->
    </div>
  </div>

  <!-- Loading Indicator -->
  <div *ngIf="gridInProgress" class="d-flex justify-content-center p-3">
    <mat-spinner diameter="40"></mat-spinner>
  </div>

  <!-- Users Table -->
  <div class="table-container" *ngIf="!gridInProgress && portalUsersPageGrid">
    <div class="table-header">
      <div class="table-info">
        <span class="user-count"> Total Users: {{ portalUsersPageGrid.total }} </span>
      </div>
    </div>

    <div class="table-wrapper">
      <table
        mat-table
        [dataSource]="portalUsersPageGrid.dataSource"
        class="users-table"
        matSort
        matPaginate
        (matSortChange)="portalUsersPageGrid.onSortChange($event)"
        (matPaginate)="portalUsersPageGrid.onPaginate($event)"
        (matPaginatorChange)="portalUsersPageGrid.onPaginate($event)"
      >
        <ng-container matColumnDef="avatarUrl">
          <th mat-header-cell *matHeaderCellDef>Avatar</th>
          <td mat-cell *matCellDef="let user">
            <div class="user-avatar">
              <img
                [src]="user.avatarUrl || 'assets/images/default-profile-pic.png'"
                [alt]="user.firstName + ' ' + user.lastName"
                class="avatar-image"
              />
            </div>
          </td>
        </ng-container>

        <ng-container matColumnDef="name">
          <th mat-header-cell *matHeaderCellDef>Name</th>
          <td mat-cell *matCellDef="let user">
            <div class="user-name">
              <span class="full-name">{{ user.firstName }} {{ user.lastName }}</span>
              <span class="user-id">ID: {{ user.id }}</span>
            </div>
          </td>
        </ng-container>

        <ng-container matColumnDef="email">
          <th mat-header-cell *matHeaderCellDef mat-sort-header>Email</th>
          <td mat-cell *matCellDef="let user">
            <div class="user-email">
              <i class="icon-mail"></i>
              {{ user.email }}
            </div>
          </td>
        </ng-container>

        <ng-container matColumnDef="nid">
          <th mat-header-cell *matHeaderCellDef>NID</th>
          <td mat-cell *matCellDef="let user">
            <div class="user-nic">
              <i class="icon-id-card"></i>
              {{ user.nid || user.passport || 'N/A' }}
            </div>
          </td>
        </ng-container>

        <ng-container matColumnDef="phoneNumber">
          <th mat-header-cell *matHeaderCellDef>Phone</th>
          <td mat-cell *matCellDef="let user">
            <div class="user-phone">
              <i class="icon-phone"></i>
              {{ user.phoneNumber || 'N/A' }}
            </div>
          </td>
        </ng-container>

        <ng-container matColumnDef="role">
          <th mat-header-cell *matHeaderCellDef>Role</th>
          <td mat-cell *matCellDef="let user">
            <span class="user-role">{{ user.role }}</span>
          </td>
        </ng-container>

        <ng-container matColumnDef="active">
          <th mat-header-cell *matHeaderCellDef mat-sort-header>Status</th>
          <td mat-cell *matCellDef="let user">
            <span class="status-badge" [ngClass]="active ? 'status-active' : 'status-inactive'">
              {{ user.active ? 'Active' : 'Inactive' }}
            </span>
          </td>
        </ng-container>

        <ng-container matColumnDef="lastLoginAt">
          <th mat-header-cell *matHeaderCellDef>Last Login</th>
          <td mat-cell *matCellDef="let user">
            <div class="last-login">
              <i class="icon-clock"></i>
              {{ user.lastLoginAt | date : 'MMM dd, yyyy HH:mm' }}
            </div>
          </td>
        </ng-container>

        <ng-container matColumnDef="actions">
          <th mat-header-cell *matHeaderCellDef>Actions</th>
          <td mat-cell *matCellDef="let user">
            <div class="action-buttons">
              <!-- <button mat-icon-button matTooltip="Edit User" (click)="onEditUser(user)" class="action-btn edit-btn">
                <i class="icon-edit"></i>
              </button>

              <button mat-icon-button matTooltip="Toggle Status" (click)="onToggleUserStatus(user)" class="action-btn toggle-btn">
                <i class="icon-toggle"></i>
              </button> -->
            </div>
          </td>
        </ng-container>

        <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
        <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
      </table>
    </div>

    <!-- Pagination -->
    <mat-paginator
      [pageSizeOptions]="pageSizes"
      [pageSize]="portalUsersPageGrid.pageSize"
      [length]="portalUsersPageGrid.total"
      [pageIndex]="portalUsersPageGrid.pageIndex"
      (page)="portalUsersPageGrid.onPaginate($event)"
      showFirstLastButtons
      aria-label="Select page of users"
    >
    </mat-paginator>
  </div>
</div>
